import { c as _c } from "react/compiler-runtime";
import { Container } from '@ordering/components/ui/Container';
import Image from 'next/image';
import ErrorImage from '@ordering/assets/boat.png';
export interface ErrorContentProps {
  title: string;
  description: string;
}
export function ErrorContent(t0) {
  const $ = _c(8);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-[194px]"><Image src={ErrorImage} alt="Boat" width={272} height={160} className="mx-auto print:hidden" priority={true} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <p className="text-[24px] mt-4 leading-[28px] font-bold">{title}</p>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <p className="mt-2 text-[16px] leading-[24px]">{description}</p>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Container><div className="text-center">{t1}<div className="px-4">{t2}{t3}</div></div></Container>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}